/* eslint-disable import/prefer-default-export */

export const formatPrice = (price = 0) => {
  if (price === 0) {
    return '';
  }

  const addCommas = num =>
    num
      .split('')
      .reverse()
      .reduce(
        (acc, curr, i) =>
          i > 1 && i % 3 === 0 ? [...acc, ',', curr] : [...acc, curr],
        []
      )
      .reverse()
      .join('');

  const [dollars, cents] = `${(price / 100).toFixed(2)}`.split('.');

  return `$${addCommas(dollars)}.${cents}`.replace(/\.00$/, '');
};
